// Reviewed
import React, { Component} from "react";
import axios from "axios";
import { ProductListCOLLECTIONURL } from "../../APIServices/ProductListRequest";
import { Link} from "react-router-dom";
import Slider from "react-slick";
import SessionHelper from "../../Helper/SessionHelper";
import { addFavBody, addFavURL } from "../../APIServices/FavRequest";
import { addFavSuccess, requestFail } from "../../Helper/ToastMassageHelper";
import { Redirect } from "react-router-dom";

class SpecialCollection extends Component {

  constructor() {
    super();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.state = {
      Next: function () {
        Slider.slickNext();
      },
      DataList: [],
      RedirectToLogin: false,
    };
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  componentDidMount() {
    this.SelectProductList();
  }
  SelectProductList = () => {
    axios.get(ProductListCOLLECTIONURL()).then((res) => {
      this.setState({ DataList: res.data });
    });
  };

  addFav = (product_code) => {
    if (SessionHelper.getLogin() !== "YES") {
      this.setState({ RedirectToLogin: true });
    } else {
      this.setState({ isLoading: "" });
      axios
        .post(addFavURL(), addFavBody(product_code))
        .then((res) => {
          if (res.status === 200 && res.data === 1) {
            addFavSuccess();
            this.setState({ isLoading: "d-none" });
          } else {
            requestFail();
            this.setState({ isLoading: "d-none" });
          }
        })
        .catch((err) => {
          this.setState({ isLoading: "d-none" });
          requestFail();
        });
    }
  };

  RedirectToLoginPage = () => {
    if (this.state.RedirectToLogin === true) {
      return <Redirect to="/login" />;
    }
  };

  render() {
    let settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };

    let products = this.state.DataList;

    if (products.length > 0) {
      if (products.length < 6) {
        let i = 0;
        while (products.length < 6) {
          products.push(this.state.DataList[i]);
          i++;
        }
      }
    }

    return (
      <>
        <div id="SpecialProduct">
          <div className="container">
            <div className="pb-3 pb-sm-5 d-flex justify-content-between">
              <h3 className="SectionTitle fw-bold">স্পেশাল পন্য</h3>
              <div className="CategoryCarousel">
                <button
                  onClick={this.previous}
                  className="prev btn btn-outline-success rounded-circle"
                  style={{ marginRight: "10px" }}
                >
                  <i className="fa-solid fa-angle-left"></i>
                </button>
                <button
                  onClick={this.next}
                  className="prev btn btn-outline-success rounded-circle"
                >
                  <i className="fa-solid fa-angle-right"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="CategoryListItem col-12">
                <Slider ref={(c) => (this.slider = c)} {...settings}>
                  {products.map((product, index) => (
                    <ProductCard
                      product={product}
                      key={index}
                      addToFav={this.addFav}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
        {this.RedirectToLoginPage()}
      </>
    );
  }
}

export default SpecialCollection;

function ProductCard({ product, addToFav }) {
  return (
    <div className="p-1">
      <div className="SpecialProductItem shadow-sm card">
        <div className="discount d-flex justify-content-center">
          <h6 className="m-0 w-75 text-white text-center">
            {checkDiscount(product)}
          </h6>
        </div>
        <div className="card-body p-0 p-sm-2">
          <Link to={"/ProductDetails/" + product.product_code}>
            <div className="image">
              <img className="img-fluid" alt="img" src={product.image} />
            </div>
            <h3 className="mt-3 fw-bold text-dark">{product.title}</h3>
            <h5 className="mt-3 mb-3 text-dark">
              {product.product_price} টাকা/{product.unit}
            </h5>
            <p className="text-secondary">
              <del>
                {product.unit_price} টাকা/{product.unit}
              </del>
            </p>
          </Link>
          <div className="d-flex justify-content-between align-items-center">
            <Link
              to={"/ProductDetails/" + product.product_code}
              className="btn btn-success SpecialProductBtn pt-2 pb-2"
              style={{ borderRadius: "25px" }}
            >
              অর্ডার করুন
            </Link>
            <button
              className="btn btn-light d-none d-sm-block p-2"
              onClick={() => addToFav(product.product_code)}
            >
              <i style={{ fontSize: 22 }} className="fa-solid fa-heart"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const checkDiscount = ({
  stock,
  discount_type,
  discount_percentage,
  flat_discount,
}) => {
  if (stock === "NO") return "স্টক আউট";
  if (stock === "CS") return "শীঘ্রই আসছে";
  if (stock === "YES" && discount_type === "Percentage")
    return `${discount_percentage}  % অফ`;
  if (stock === "YES" && discount_type === "Flat")
    return `${flat_discount} টাকা ডিস্কাউন্ট`;
  return "";
};
